import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type AmbienteHeader = 'producao' | 'homologacao' | 'desenvolvimento';

@Injectable({
  providedIn: 'root'
})
export class AmbienteHeaderService {
  private readonly ambienteSubject = new BehaviorSubject<AmbienteHeader>('producao');
  readonly ambiente = this.ambienteSubject.asObservable();

  aplicar(ambiente: string): void {
    const normalizado = this.normalizar(ambiente);
    document.documentElement.setAttribute('data-ambiente', normalizado);
    if (this.ambienteSubject.value !== normalizado) {
      this.ambienteSubject.next(normalizado);
    }
  }

  get valor(): AmbienteHeader {
    return this.ambienteSubject.value;
  }

  get rotulo(): string {
    if (this.valor === 'homologacao') {
      return 'QA';
    }
    if (this.valor === 'desenvolvimento') {
      return 'DEV';
    }
    return '';
  }

  private normalizar(ambiente: string): AmbienteHeader {
    const valor = (ambiente || '').toLowerCase();
    if (valor === 'homologacao' || valor === 'homologação') {
      return 'homologacao';
    }
    if (valor === 'desenvolvimento') {
      return 'desenvolvimento';
    }
    return 'producao';
  }
}
